<script>
	import { LottiePlayer } from '@lottiefiles/svelte-lottie-player';
	import CompareModule from './CompareModule.svelte';
	import { route } from './stores.js'

	let files = {}
	let drag;

	function setFile(id, e){
		if(!e.dataTransfer || !e.dataTransfer.files) {
			if(!e.target.files)
				return false;
			else
				var fileList = e.target.files
		}else{
			fileList = e.dataTransfer.files;
		}
		if(!verifyFiles(fileList)) return;
		id = id===undefined?Math.min(1, Object.keys(files).length):id;
		files[id] = {url: URL.createObjectURL(fileList[0]), file: fileList[0]};
	}

	function drop (e) {
		e.preventDefault();
		e.stopPropagation();
		dragleave(e);
		setFile(undefined, e)
		return false;
	}
	function dragenter (e) {
		e.preventDefault();
		e.stopPropagation();
		clearInterval(drageneter.interval);
		drageneter.interval = setTimeout(() => dragleave(e), 400)
		drag = true;
	}
	function dragleave (e) {
		e.preventDefault();
		e.stopPropagation();
		drag = false;
	}
	function verifyFiles (fileList) {
		fileList = Array.prototype.filter.call(fileList, file => {
			return file.type.includes("image")
		})
		return fileList.length > 0;
	}

	window.addEventListener('paste', (e) => {
		if(!e.clipboardData || !e.clipboardData.items) return false;
		let images = Array.prototype.map.call(e.clipboardData.items, img => {
			return img.getAsFile();
		}).filter(item => item);
		if(!verifyFiles(images)) return;
		let id = Math.min(1, Object.keys(files).length);
		files[id] = {url: URL.createObjectURL(images[0]), file: images[0]};
	});

	let root;
	let compare = 0;
</script>

<div class="Compare" bind:this={root} class:drag>
	<button class="button-float" data-icon="keyboard_arrow_left" on:click={() => {$route = ''}}>Back</button>
	<div class="player">
		<LottiePlayer
		  src="anim/circle.json"
		  autoplay="{true}"
		  loop="{true}"
		  controls="{false}"
		  renderer="svg"
		  background="transparent"
		  speed={0.5}
		/>
	</div>
	<h1>Verification check</h1>
	<div class="controls">
		<div class="control">
			<h2>Photo 1</h2>
			<label class="photo-label" style="background-image:url({files[0]?.url||''})">
				{#if files[0]}
					<!-- <img class="preview" src={files[0]} /> -->
				{:else}
					<img src="img/camera-plus.svg">
					<span>Upload photo</span>
				{/if}
				<input type="file" style="display: none" on:change={(e) => setFile(0, e)} />
			</label>
		</div>
		<div class="control">
			<h2>Photo 2</h2>
			<label class="photo-label" style="background-image:url({files[1]?.url||''})">
				{#if files[1]}
					<!-- <img class="preview" /> -->
				{:else}
					<img src="img/camera-plus.svg">
					<span>Upload photo</span>
				{/if}
				<input type="file" style="display: none" on:change={(e) => setFile(1, e)}/>
			</label>
		</div>
	</div>
	{#if Object.keys(files).length > 1}
		<button class="button" on:click={() => compare = true}>Compare</button>
	{/if}
	<img src="./img/logo-white.webp" alt="MyID" />
	{#if compare && Object.keys(files).length > 1}
		<CompareModule image={files[0].file} image2={files[1].file} on:reset={() => compare = 0} />
	{/if}
</div>

<style>
	.Compare {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		padding: 1em;
	}

	.controls {
		display: flex;
		margin: auto 0;
		flex-wrap: wrap;
		position: relative;
		top: -1em;
	}

	h1 {
		font-weight: normal;
		font-size: 3em;
		margin-top: 1.5em;
	}

	.control {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		font-size: 1.4em;
	}

	.control + .control {
		margin-left: 6em;
	}

	.control h2 {
		font-weight: normal;
		font-size: 1.5em;
	}

	.photo-label {
		background: #a291f5;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 10em;
		width: 13em;
		border-radius: 0.5em;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background-size: cover;
		background-position: 50% 50%;
	}


	.photo-label img {
		margin-bottom: 1em;
		width: 2em;
	}

	.player {
		position: absolute;
		width: 50vh;
		top: 0;
		bottom: 0;
		pointer-events: none;
		top: 25vh;
		z-index: -1;
	}

	.Compare > img {
		min-height: 4em;
		max-height: 4em;
		margin-top: 7em;
	}
	.button {
		background: #a291f5;
		border: none;
		border-radius: 4px;
		color: white;
		padding: 0.7em 1.5em;
		min-width: 10em;
		cursor: pointer;
		font-size: 1.4em;
	}
	.button-float {
		background: rgba(10, 10, 10, 0.4);
		color: white;
		font-size: 1.2em;
		position: absolute;
		border: none;
		border-bottom: 1px solid rgba(255, 255, 255, 0.2);
		width: 100%;
		text-align: left;
		padding: 0;
		line-height: 2.4em;
		padding-left: 0.5em;
		margin: 0;
		cursor: pointer;
		z-index: 2;
		top: 0;
	}
	.button-float:hover {
		background: rgba(0,0,0,0.5);
	}

	@media (max-width: 800px) {
		.controls {
			flex-direction: column;
			margin: 0;
			font-size: 0.8em;
		}
		.control {
			margin: 0 !important;
		}
		.button {
			margin-top: 1em;
		}
	}
</style>